import React from 'react';
import { Box, MenuItem, Select, Typography } from '@mui/material';

const PAGE_SIZES = [10, 25, 50, 100];

const PaginationInfo = ({
  currentPage,
  perPage,
  totalCount,
  showText = 'Showing',
  showCenter = true,
  showRowCount = false,
  setPerPage,
}) => {
  if (totalCount === 0) return null;

  const startRecord = (currentPage - 1) * perPage + 1;
  const endRecord = Math.min(currentPage * perPage, totalCount);

  const displayMessage =
    totalCount === 1
      ? `${showText} ${startRecord} of ${totalCount} record`.trim()
      : `${showText} ${startRecord} to ${endRecord} of ${totalCount} records`.trim();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: showCenter ? 'center' : 'flex-end',
        gap: 2,
        m: showCenter ? '8px auto' : '4px 0',
      }}
    >
      {showRowCount && setPerPage && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: 'nowrap' }}
          >
            Rows per page:
          </Typography>
          <Select
            value={perPage}
            onChange={setPerPage}
            size="small"
            variant="outlined"
            inputProps={{ 'aria-label': 'rows per page' }}
            sx={{
              width: 64,
              fontSize: '0.8125rem',
              '& .MuiSelect-select': {
                py: '4px !important', // Override large theme padding
                px: '8px !important',
              },
            }}
          >
            {PAGE_SIZES.map((size) => (
              <MenuItem key={size} value={size} sx={{ fontSize: '0.8125rem' }}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {displayMessage}
      </Typography>
    </Box>
  );
};

export default PaginationInfo;